export default __webpack_public_path__ + "static/media/text.5f1600a4.wav";